import {
  HubFilter,
  HubFilterOption,
} from '@/shared/components/filter/hub-filter';
import {
  useActiveProjectHubFilterCount,
  useProjectHubFilterStore,
} from '@/shared/hooks/use-hub-filter-store';

export const ProjectHubFilter = () => {
  return (
    <HubFilter
      {...useProjectHubFilterStore()}
      activeCount={() => useActiveProjectHubFilterCount()}
      options={[
        HubFilterOption.STATUS,
        HubFilterOption.PARTNER,
        HubFilterOption.ROLE,
        HubFilterOption.NOTIFICATION_STATUS,
        HubFilterOption.LAST_ENTRY,
      ].map((option) => ({
        option,
      }))}
    />
  );
};
